module.exports = ["#F44336","#FF9800","#FFEB3B","#8BC34A","#009688","#2196F3","#673AB7","#9C27B0","#E91E63","#3F51B5"]


//////////////////
// WEBPACK FOOTER
// ./src/fan/proyecto/components/esquemas/esquema/comisionistas/colores.json
// module id = 584
// module chunks = 0